"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketAnalyticsConfigurationInput_1 = require("./DeleteBucketAnalyticsConfigurationInput");
var DeleteBucketAnalyticsConfigurationOutput_1 = require("./DeleteBucketAnalyticsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketAnalyticsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketAnalyticsConfiguration",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?analytics"
    },
    input: {
        shape: DeleteBucketAnalyticsConfigurationInput_1.DeleteBucketAnalyticsConfigurationInput
    },
    output: {
        shape: DeleteBucketAnalyticsConfigurationOutput_1.DeleteBucketAnalyticsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketAnalyticsConfiguration.js.map